// Set picker: radio cards submit form quantity (1/2/3 sets); the CTA total mirrors the selected card's Liquid-formatted price.
class SSetPicker extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.name !== 'quantity') return;
      this.update(input);
    }, { signal: this.controller.signal });
    const checked = this.querySelector('input[name="quantity"]:checked');
    if (checked) this.update(checked);
  }

  update(input) {
    const form = this.closest('form');
    const variant = form?.querySelector('input[name="id"]');
    if (variant && input.dataset.variantId) variant.value = input.dataset.variantId;
    const total = this.querySelector('[data-cta-total]');
    if (total && input.dataset.total) total.textContent = input.dataset.total;
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

if (!customElements.get('s-set-picker')) customElements.define('s-set-picker', SSetPicker);
